import {AppComponent} from "../app.component";
import {ActivatedRoute} from "@angular/router";
import {Router} from "@angular/router";
import {FormGroup} from "@angular/forms";
import {FormControl} from "@angular/forms";
import {ElementRef, NgZone, ViewContainerRef} from "@angular/core";
import {AppValidator} from "../app-validator";
import {SelectItem} from "../model/db/pojo/common/SelectItem";
import {DataTableDataHelper} from "../model/app/DataTableDataHelper";
import {DataTableListModel} from "../model/app/DataTableListModel";
import {ChangeDetectorRef} from "@angular/core";
import {LazyLoadEvent, DataTable} from "primeng/primeng";
import {UIHelper} from "../uihelper";
import {HttpClient} from "@angular/common/http";
import {formatLineChar} from "awesome-typescript-loader/dist/helpers";
import {AppCurrentModule} from "../app-current-module";
import {CookieService} from "ngx-cookie-service";

declare var userDisabled: any;

export class ComponentBase {

    public http: HttpClient;
    public router: Router;
    public appComponent: AppComponent = AppComponent.instance;
    public route: ActivatedRoute;
    public zone: NgZone;
    public appValidator: AppValidator;
    public changeDetectorRef: ChangeDetectorRef;
    public elementRef: ElementRef;
    public initialData = null;
    public componentID = null;
    public viewContainerRef: ViewContainerRef;
    public viewStore = {};
    public roleCache = {
        isAdmin: false
    };
    public appCurrentModule: AppCurrentModule;
    public cookieService: CookieService;

    constructor() {
        try {
            this.http = this.appComponent.http;
            this.router = this.appComponent.router;
            this.zone = this.appComponent.zone;
            this.appValidator = this.appComponent.appValidator;
            this.changeDetectorRef = this.appComponent.changeDetectorRef;
            this.elementRef = this.appComponent.appElement;
            this.viewContainerRef = this.appComponent.viewContainerRef;
            this.componentID = this.getNextUniqueID();
            this.cookieService = this.appComponent.cookieService;
            if (this.appComponent.initialData != null && this.appComponent.lastInitialData != null && this.appComponent.lastInitialData != this.router.url) {
                this.appComponent.initialData = null;
                this.appComponent.lastInitialData = null;
            }
            if (this.appComponent.initialData != null) {
                this.initialData = this.shallowCloneObject(this.appComponent.initialData);
                this.appComponent.lastInitialData = this.router.url;
            }
            this.appCurrentModule = this.appComponent.appCurrentModule;
        } catch (ex) {
        }
        if (typeof this.appComponent !== 'undefined' && typeof this.appComponent.appData !== 'undefined') {
            this.roleCache.isAdmin = this.appComponent.appData.userIsAdmin;
        }
    }

    public navigateWithInitialData(path: string, initialData: any) {
        this.appComponent.lastInitialData = path;
        this.appComponent.initialData = initialData;
        this.router.navigate([path]);
    }

    public resetForm(formGroup: FormGroup) {
        for (let itemKey in formGroup) {
            //form.controls[control].updateValue('');
            let item: FormControl = formGroup[itemKey];
            item.setErrors(null);
        }

    }

    public assignVar(varName: string, varValue: any, varText: string): string {
        return varText.replace('{' + varName + '}', varValue + '');
    }

    public scrollTop() {
        $("html, body").animate({scrollTop: 0}, "fast");
    }

    public scrollTopId(objId) {
        $('html, body').animate({scrollTop: $('#' + objId).position().top}, 'fast');
    }

    public strAddContextPathToURLs(tText: string): string {
        if ((getContextPath() == "") || (getContextPath() == "/")) {
            return tText;
        }
        var obj = $("<div>" + tText + "</div>");
        obj.find("a").attr("href", function (i, href) {
            if (typeof href == 'undefined') {
                return href;
            }
            if ((href.indexOf("http://") == 0) || (href.indexOf("https://") == 0)) {
                return href;
            }
            return getContextPath() + href;
        });
        obj.find("img").attr("src", function (i, src) {
            if (typeof src == 'undefined') {
                return src;
            }
            if ((src.indexOf("http://") == 0) || (src.indexOf("https://") == 0)) {
                return src;
            }
            return getContextPath() + src;
        });
        return obj.html();
    }

    public strRemoveContextPathToURLs(tText: string): string {
        if ((getContextPath() == "") || (getContextPath() == "/")) {
            return tText;
        }
        var obj = $("<div>" + tText + "</div>");
        obj.find("a").attr("href", function (i, href) {
            if (typeof href == 'undefined') {
                return href;
            }
            if ((href.indexOf("http://") == 0) || (href.indexOf("https://") == 0)) {
                return href;
            }
            if (href.indexOf(getContextPath()) == 0) {
                href = href.substring(getContextPath().length);
            }
            return href;
        });
        obj.find("img").attr("src", function (i, src) {
            if (typeof src == 'undefined') {
                return src;
            }
            if ((src.indexOf("http://") == 0) || (src.indexOf("https://") == 0)) {
                return src;
            }
            if (src.indexOf(getContextPath()) == 0) {
                src = src.substring(getContextPath().length);
            }
            return src;
        });
        return obj.html();
    }

    public addNextIndexedFormGroupControl(formGroup: FormGroup, formControlNamePrefix: string, formControl: FormControl) {
        let maxIndex = -1;
        for (let item in formGroup) {
            if (item.indexOf(formControlNamePrefix + "_") == 0) {
                try {
                    let itemItems = item.split("\\_");
                    maxIndex = parseInt(itemItems[itemItems.length - 1])
                } catch (e) {
                }
            }
        }

        if (maxIndex > -1) {
            maxIndex += 1;
        } else {
            maxIndex = 0;
        }

        formGroup.addControl(formControlNamePrefix + '_' + maxIndex, formControl);
    }

    public getNextRowKey(items: any): number {
        let maxRowKey = -1;
        let nextRowKey = -1;
        for (let item of items) {
            if (typeof item.rowKey !== 'undefined') {
                nextRowKey = item.rowKey;
            }
            if (nextRowKey > -1 && nextRowKey > maxRowKey) {
                maxRowKey = nextRowKey;
            }
        }

        if (maxRowKey > -1) {
            maxRowKey += 1;
        } else {
            maxRowKey = 0;
        }

        return maxRowKey;
    }

    public cloneObject<T>(obj: T): T {
        return UIHelper.cloneObject(obj);
    }

    public shallowCloneObject<T>(obj: T): T {
        return UIHelper.shallowCloneObject(obj);
    }

    public getNextUniqueID() {
        this.appComponent.uniqueIDSerial += 1;
        return this.appComponent.uniqueIDSerial + "";
    }

    public focusInput(element: any) {
        element.nativeElement.focus();
        this.appComponent.preventTabEnter = true;
    }

    public focusNextInput(event) {
        if (this.appComponent.preventTabEnter) {
            this.appComponent.preventTabEnter = false;
            return false;
        }
        if (userDisabled) {
            return false;
        }
        if (!$(event.srcElement).hasClass('no-catch-enter') && !$(event.srcElement).hasClass('ui-autocomplete-list-item')) {
            var form = $(event.srcElement).parents('form:first');

            let focusable = $("#mainContent").find('input:enabled,a:enabled:not(.ui-paginator-element),select:enabled,button:enabled,textarea:enabled').filter(':visible').not('.skip-focus, .ui-helper-hidden-accessible > select');
            let next = focusable.eq(focusable.index(event.srcElement) + 1);

            if (next.length) {
                next.focus();
            } else {
                /*if (!$(event.srcElement).hasClass('no-submit-enter')) {
                 //form.submit();
                 }*/
            }
            event.preventDefault();
            return false;
        }
    }

    public getAZSelectItems(withNone: boolean = true): SelectItem[] {
        let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let returnItems: SelectItem[] = [];
        if (withNone) {
            let selectItem = new SelectItem();
            selectItem.value = -1;
            selectItem.label = "-"
            returnItems.push(selectItem);
        }
        for (let i = 0; i < chars.length; i++) {
            let selectItem = new SelectItem();
            selectItem.value = i;
            selectItem.label = chars[i];
            returnItems.push(selectItem);
        }
        return returnItems;
    }

    public resetTable(table: any) {
        try {
            if (typeof table !== undefined) {
                let offPaginator = false;
                if (!table.paginator) {
                    offPaginator = true;
                    table.paginator = true;
                }
                table.reset();
                table.updatePaginator();
                table.selection = null;
                if (offPaginator) {
                    table.paginator = false;
                }
            }
        } catch (e) {
        }
    }

    findElements(selector: string): any[] {
        return this.appComponent.appElement.nativeElement.querySelectorAll(selector);
    }

    findElement(selector: string): any {
        return this.appComponent.appElement.nativeElement.querySelector(selector);
    }

    public getURLPath() {
        let urlHash = window.location.hash;
        if (urlHash.indexOf("#") === 0) {
            urlHash = urlHash.substring(1);
            if (urlHash.indexOf(";") !== -1) {
                let urlHashArray = urlHash.split(";");
                urlHash = urlHashArray[0];
            }
        }
        /*
         for (var i = 0; i < this.route.snapshot.url.length; i++) {
         addr += '/' + this.route.snapshot.url[i].path;
         }
         return addr;
         */
        return urlHash;
    }

    public getExternalLink(linkKey: string, assignItems: any): string {
        let externalLink = '';

        if (typeof this.appComponent.externalLinks[linkKey] !== 'undefined') {
            externalLink = this.appComponent.externalLinks[linkKey];
        }

        if (assignItems !== null) {
            for (let assignItem of assignItems) {
                externalLink = this.assignVar(assignItem.varName, assignItem.varValue, externalLink);
            }
        }

        return externalLink;
    }

    public getCombolistWithAll(comboValuesOriginal: any, mode: number): any {
        return UIHelper.getCombolistWithAll(comboValuesOriginal, mode);
    }

    public getComboboxFirstValue(comboValues: any): any {
        return UIHelper.getComboboxFirstValue(comboValues);
    }

    public getComboboxSelectItemByValue(comboValues: any, value): any {
        for (let item of comboValues) {
            if (item.value == value) {
                return item;
            }
        }
        return null;
    }

    public processLazyLoadEvent(event: LazyLoadEvent, override = null): DataTableDataHelper {
        let eventData = new DataTableDataHelper();

        if (event !== null) {
            eventData.offset = event.first;
            eventData.rowCount = event.rows;
            if (override == null || (override != null && event.sortField != null)) {
                eventData.sortField = event.sortField;
                eventData.sortOrder = event.sortOrder;
            } else {
                eventData.sortField = override.sortField;
                eventData.sortOrder = override.sortOrder;
            }
            if (typeof event.filters != 'undefined') {
                eventData.filters = event.filters;
            }
        }

        return eventData;
    }

    public processLazyLoadResult(listModel: DataTableListModel, dataTable: DataTable, listItems: any, rowCount: any, firstRow: number = -1, listItemsSummary: any = null, notifyRowCountChanged = true) {
        listModel.listItems = listItems;
        listModel.rowCount = rowCount;
        listModel.listItemsSummary = listItemsSummary;

        if (listModel.lastRowCount != rowCount) {
            if (notifyRowCountChanged && listModel.lastRowCount != -1) {
                this.appComponent.addGrowlWarningMessage(this.appComponent.getTranslation("attention"), this.appComponent.getTranslation("dataTableRowCountChanged"))
            }
            listModel.lastRowCount = rowCount;
        }
        if (firstRow > -1) {
            if (firstRow == 0) {
                listModel.isFirstPage = true;
            } else {
                listModel.isFirstPage = false;
            }
            listModel.currentPage = Math.floor(firstRow / listModel.itemListViewRows) + 1;
            listModel.pageCount = Math.ceil(rowCount / listModel.itemListViewRows) || 1;
            listModel.isLastPage = (listModel.currentPage === listModel.pageCount);

            //listModel.itemListFirst = firstRow;
            //console.log(firstRow);
            //console.log(listModel.itemListFirst);
            if (listModel.isLastPage) {
                try {
                    listModel.itemListLastRowIndex = (((listModel.pageCount - 1) * listModel.itemListViewRows) + listModel.listItems.length - 1);
                } catch (e) {
                    listModel.itemListLastRowIndex = 0;
                }
            }
        }
        this.markForCheck(dataTable);
    }

    public unionObject(obj1: any, ...obj2: any[]) {
        let item = obj1;
        obj2.forEach(obj => {
            item = Object.assign(item, obj);
        });
        return item;
    }

    public getStringFormattedDate(srcDate: Date) {
        var mm = (srcDate.getMonth() + 1).toString();
        var dd = srcDate.getDate().toString();

        return [srcDate.getFullYear(), '-', mm.length === 2 ? '' : '0', mm, '-', dd.length === 2 ? '' : '0', dd].join('');
    }

    public getStringCalendarFormattedDate(srcDate: Date) {
        var mm = (srcDate.getMonth() + 1).toString();
        var dd = srcDate.getDate().toString();

        return [srcDate.getFullYear(), '.', mm.length === 2 ? '' : '0', mm, '.', dd.length === 2 ? '' : '0', dd, '.'].join('');
    }

    public autoCompleteHasValue(value: any) {
        return (typeof value !== 'undefined') && value !== null && value.hasOwnProperty('value');
    }

    public safeAddArrayValue(targetArray: any, value: any, key1: string, key2: string = null, key3: string = null, key4: string = null, key5: string = null) {
        /* if (typeof targetArray === 'undefined') {
         targetArray = [];
         } */
        if (key1 !== null && typeof targetArray[key1] === 'undefined') {
            targetArray[key1] = [];
        }
        if (key2 !== null && typeof targetArray[key1][key2] === 'undefined') {
            targetArray[key1][key2] = [];
        }
        if (key3 !== null && typeof targetArray[key1][key2][key3] === 'undefined') {
            targetArray[key1][key2][key3] = [];
        }
        if (key4 !== null && typeof targetArray[key1][key2][key3][key4] === 'undefined') {
            targetArray[key1][key2][key3][key4] = [];
        }
        if (key5 !== null && typeof targetArray[key1][key2][key3][key4][key5] === 'undefined') {
            targetArray[key1][key2][key3][key4][key5] = [];
        }

        if (key5 !== null) {
            targetArray[key1][key2][key3][key4][key5] = value;
        } else if (key4 !== null) {
            targetArray[key1][key2][key3][key4] = value;
        } else if (key3 !== null) {
            targetArray[key1][key2][key3] = value;
        } else if (key2 !== null) {
            targetArray[key1][key2] = value;
        } else {
            targetArray[key1] = value;
        }
    }

    markForCheck(item: any) {
        setTimeout(() => {
            if (typeof item !== 'undefined') {
                item.changeDetector.markForCheck();
                item.changeDetector.detectChanges();
            }
        });
    }

    clearTableSelection(item: any) {
        setTimeout(() => {
            if (typeof item !== 'undefined') {
                item.selection = [];
                item.selectionChange.emit(item.selection);
                item.changeDetector.markForCheck();
                item.changeDetector.detectChanges();
            }
        });
    }

    encodeURI(url: string) {
        return encodeURI(url);
    }

    getCommandUrl(path, command) {
        return this.assignVar('command', command, this.assignVar('path', path, appSettingsData['urlString']));
    }

    mailTo(address: string) {
        this.appComponent.checkOnUnload = false;
        setTimeout(function () {
            document.location.href = 'mailto:' + address;
        }, 100);
        return false;
    }

    alert(message: string) {
        alert(message);
    }

    mapResultToObject(src, dest) {
        for (let destKey in dest) {
            if (typeof src[destKey] !== 'undefined') {
                dest[destKey] = src[destKey];
            }
        }
    }

    setTmpStoreDataTableDefaultOptions(name: string) {
        if (typeof this.appComponent.tmpStore[name] == 'undefined') {
            this.appComponent.tmpStore[name] = {
                'rows': 50,
                'rowsPerPageOptions': [50, 100, 200]
            }
        }
    }

    storeScrollAndGoUp() {
        this.viewStore['scrollTop'] = $(document).scrollTop();
        $(document).scrollTop(0)
    }

    restoreScroll() {
        $(document).scrollTop(this.viewStore['scrollTop']);
    }

    getApiUrl() {
        return getApiUrl();
    }

    parseBlobResponseError(response) {
        let handled = false;
        try {
            if (response.status == 401) {
                //AppComponent.instance.accountHandlingComponent.reloginUser();
                window.location.hash = '';
                window.location.href = getContextPath() + '/';
                enableUser();
                handled = true;
            }
        } catch (e) {
        }
        try {
            let reader = new FileReader();
            reader.readAsText(response.error);
            reader.onload = () => {
                try {
                    let resultData = JSON.parse(reader.result + '');
                    if (resultData.result.resultStatus == 'NOTOK' && typeof resultData.result.resultMessage !== 'undefined') {
                        this.appComponent.addGrowlMessage('error', 'Error!', resultData.result.resultMessage);
                        handled = true;
                        enableUser();
                    }
                    if (typeof resultData.result.growlMessages !== 'undefined') {
                        for (var i = 0; i < resultData.result.growlMessages.length; i++) {
                            var growlMessage = resultData.result.growlMessages[i];
                            this.appComponent.addGrowlMessage(growlMessage.type, growlMessage.summary, growlMessage.detail);
                        }
                        handled = true;
                    }
                    if (typeof resultData.result.stickyGrowlMessages !== 'undefined') {
                        for (var i = 0; i < resultData.result.stickyGrowlMessages.length; i++) {
                            var growlMessage = resultData.result.stickyGrowlMessages[i];
                            this.appComponent.addStickyGrowlMessage(growlMessage.type, growlMessage.summary, growlMessage.detail);
                        }
                        handled = true;
                    }
                } catch (e) {
                    this.appComponent.addStickyGrowlMessage('error', 'Ismeretlen hiba', 'Kérem próbálja a műveletet újra.');
                    enableUser();
                }
                return handled;
            };
            reader.onerror = () => {
                this.appComponent.addStickyGrowlMessage('error', 'Ismeretlen hiba', 'Kérem próbálja a műveletet újra.');
                handled = true;
                enableUser();
            }
        } catch (e) {
            this.appComponent.addStickyGrowlMessage('error', 'Ismeretlen hiba', 'Kérem próbálja a műveletet újra.');
            handled = true;
            enableUser();
        }
        return handled;
    }

    isTrue(value) {
        if (typeof (value) === 'string') {
            value = value.trim().toLowerCase();
        } else {
            return value;
        }
        switch (value) {
            case true:
            case "true":
            case 1:
            case "1":
            case "on":
            case "yes":
                return true;
            default:
                return false;
        }
    }

    arrayContainsObjectValue(sourceObject, destObject, key) {
        for (let item of sourceObject) {
            if (item[key] == destObject[key]) {
                return true;
            }
        }
        return false;
    }

    rgb2hex(rgb) {
        rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);

        function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
        }

        return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }

    padDigits(number, digits) {
        return Array(Math.max(digits - String(number).length + 1, 0)).join('0') + number;
    }

    clearArray<T>(array: T[]) {
        while (array.length) {
            array.pop();
        }
    }

    queueArrayNext(queue, afterFunc) {
        queue.shift();
        if (queue.length > 0) {
            return true;
        } else {
            if (afterFunc != null) {
                afterFunc();
            }
            return false;
        }
    }

    getYearCookieTime() {
        return 3600 * 1000 * 24 * 365 * 10;
    }

    copyTextToClipboard(str) {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.appComponent.addGrowlInfoMessage("Információ", "Vágólapra másolás megtörtént!");
    }
}
